import * as deviceHistory from '../actionTypes/Accounts/userAccounts'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'

function getDeviceHistoryListSuccess (deviceHistoryList) {
  return {
    type: deviceHistory.GET_DEVICE_HISTORY_LIST,
    deviceHistoryList: deviceHistoryList
  }
}

export const getDeviceHistoryList = (data, callBack) => {
  let page = (data.page !== 0) ? data.page : 1
  let pagenumber = '?PageNumber=' + page
  let criteria = '&criteria=' + data.search
  let filter = '&filter=' + data.filter
  let sortcolumn = '&sortcolumn=' + data.sc
  let SortingType = '&SortingType=' + data.st
  let RecordPerPage = '&RecordPerPage=' + data.perPage
  let query = pagenumber + criteria + filter + sortcolumn + SortingType + RecordPerPage
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getdeviceHistory + query
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let deviceHistoryData = data.data
      dispatch(getDeviceHistoryListSuccess(deviceHistoryData))
      callBack(deviceHistoryData)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/devicehistorylist.js